export const tableContent = [
  [
    'Restriction:',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed augue mauris, ultrices sed erat sed, facilisis consequat orci. Sed luctus quis nisl ut porttitor.'
  ],
  [
    'Frequency:',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed augue mauris, ultrices sed erat sed, facilisis consequat orci. Sed luctus quis nisl ut porttitor.'
  ],
  [
    'Exam Services:',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed augue mauris, ultrices sed erat sed, facilisis consequat orci. Sed luctus quis nisl ut porttitor.'
  ],
  [
    'Contact Lens Fit and Follow:',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed augue mauris, ultrices sed erat sed, facilisis consequat orci. Sed luctus quis nisl ut porttitor.'
  ],
  [
    'Frame:',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed augue mauris, ultrices sed erat sed, facilisis consequat orci. Sed luctus quis nisl ut porttitor.'
  ],
  [
    'Lens:',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed augue mauris, ultrices sed erat sed, facilisis consequat orci. Sed luctus quis nisl ut porttitor.'
  ],
  [
    'Lens Options:',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed augue mauris, ultrices sed erat sed, facilisis consequat orci. Sed luctus quis nisl ut porttitor.'
  ],
  [
    'Contact Lenses:',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed augue mauris, ultrices sed erat sed, facilisis consequat orci. Sed luctus quis nisl ut porttitor.'
  ]
]
